import React, { useState } from 'react';
import './EventSingle.css';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle, Service, Category, Venue } from '../../../components';
import { eventMenu, services, venues } from '../../../constants';
import { getItemsByIds, getMenuCategories } from '../../../utils';

// Import FontAwesome icon
import { FaArrowRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

import { useLocation } from 'react-router-dom';



const EventSingle = () => {

  // State to manage the active tab
  const [activeTab, setActiveTab] = useState('overview');

  // Function to handle tab switching
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Get event data passed from the previous page
  const location = useLocation();
  const event = location.state;

  // Event Services
  const eventServices = getItemsByIds(event.services, services);

  // Event Venues
  const eventVenues = getItemsByIds(event.venues, venues);

  // Event Menu Categories
  const getMenuCategoriesForEvent = (menu, event) => {

    if (!event.menuCategories || !Array.isArray(event.menuCategories)) {
      return [];
    }

    // Filter the full menu based on event.menuCategories
    const filteredMenu = Object.fromEntries(
      Object.entries(menu).filter(([key]) => event.menuCategories.includes(key))
    );

    // Use the existing function to format the result
    return getMenuCategories(filteredMenu);

  };

  const eventMenus = getMenuCategoriesForEvent(eventMenu, event);


  return (
    <>

      {/* Page Title Section */}
      <PageTitle title={event.title} page={'Event Single'} />

      <section className='event-single page-single'>

        <div className="event-info page-info">

          {/* Event Image */}
          <div className="image">
            <img src={event.image} alt={event.title} />
          </div>

          {/* Event Content */}
          <div className="content tab-info">

            {/* Event Info Tabs - Tab Buttons */}
            <div className="event-info-tabs tab-buttons">
              <button 
                type="button" 
                className={`button ${activeTab === 'overview' ? 'active' : ''}`} 
                onClick={() => handleTabClick('overview')}
              >
                Overview
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'services' ? 'active' : ''}`} 
                onClick={() => handleTabClick('services')}
              >
                Services
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'menu' ? 'active' : ''}`} 
                onClick={() => handleTabClick('menu')}
              >
                Sample Menu
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'venues' ? 'active' : ''}`} 
                onClick={() => handleTabClick('venues')}
              >
                Venues
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'gallery' ? 'active' : ''}`} 
                onClick={() => handleTabClick('gallery')}
              >
                Gallery
              </button>
            </div>

            {/* Event Info Tabs - Tab Sections */}
            <div className="tab-sections">

              {/* Overview Tab Section */}
              {activeTab === 'overview' && (

                <div className="overview tab-section active">

                  {/* Event Title */}
                  <h3 className='main-heading'>{event.title}</h3>

                  {/* Event Content */}
                  {event.overviews.map((overview, index) => (
                    <p key={index}>{overview}</p>
                  ))}

                  {/* Event Highlights */}
                  <div className='event-highlights sub-section'>
        
                    <h3 className='sub-heading'>Event Highlights:</h3>
        
                    <p>Our catering service for {event.title} includes exceptional offerings and tailored experiences such as:</p>
        
                    {/* List of Event Highlights */}
                    <ul>
                      {event.highlights.map((highlight, index) => {
                        return <li key={index}><div className='icon'><FaArrowRight /></div>{highlight}</li>
                      })}
                    </ul>
        
                  </div>

                  {/* Key Benefits */}
                  <div className='event-benefits sub-section'>

                    <h3 className='sub-heading'>Key Benefits:</h3>
                    <p>Choosing our catering service for {event.title} brings a range of exclusive advantages, including:</p>

                    {/* List of Key Benefits */}
                    <ul>
                      {event.benefits.map((benefit, index) => {
                        return <li key={index}><div className='icon'><FaCheck /></div>{benefit}</li>
                      })}
                    </ul>

                  </div>

                  {/* Customization Options */}
                  <div className='customization sub-section'>

                    <h3 className='sub-heading'>Customization Options:</h3>

                    <p>We tailor our catering offerings for {event.title} to match your unique preferences and event requirements, including:</p>

                    {/* List of Customization Options */}
                    <ul>
                      {event.customizations.map((customization, index) => {
                        return <li key={index}><div className='icon'><FaCircleNotch/></div>{customization}</li>
                      })}
                    </ul>

                  </div>

                </div>
              )}

              {/* Services Tab Section */}
              {activeTab === 'services' && (
                <div className="services tab-section">
                  <div className='box-container'>

                    {/* Map over the event services array to render each service */}
                    {eventServices.map((service) => { 
                      return <Service key={service.id} service={service} />
                    })}

                  </div>
                </div>
              )}

              {/* Menu Categories Tab Section */}
              {activeTab === 'menu' && (
                <div className="menu-categories tab-section">
                  <div className='box-container'>

                  {eventMenus.map(({ index, category, image }) => (
                    <Category
                      key={index}
                      index={index}
                      category={category}
                      image={image}
                      menuType="event" // Explicitly set to 'event' for event categories
                    />
                  ))}

                  </div>
                </div>
              )}

              {/* Venues Tab Section */}
              {activeTab === 'venues' && (
                <div className="venue-partners tab-section">
                  <div className='box-container'>
          
                    {/* Map over the venues array to render each venue */}
                    {eventVenues.map((venue) => { 
                      return <Venue key={venue.id} venue={venue} />
                    })}
          
                  </div>
                </div>
              )}

              {/* Gallery Tab Section */}
              {activeTab === 'gallery' && (
                <div className="tab-section">
                  {/* Event Image gallery */}
                  <Lightbox images={event.gallery} />
                </div>
              )}

            </div>
          </div>
        </div>

        {/* Event Sidebar Section */}
        <PageSidebar
          heading={'Event'}
          details={event.details}
        />

      </section>

     </>
  );
};

export default EventSingle;